import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {Budget} from '../../interfaces';
import {FormsModule, UntypedFormControl} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import {CompanySearchComponent} from '../../shared/company-search/company-search.component';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';


@Component({
    template: `
        <div mat-dialog-content style="margin-bottom: 10px">
          <h2>Preparing offer for budget {{budget.budgetNr}}</h2>
          <mat-radio-group [(ngModel)]="useDefaultCompany" style="display: flex; flex-direction: column; gap: 15px">
            <mat-radio-button [value]="true">
              use the default company <strong>{{budget.company.companyName}}</strong>
            </mat-radio-button>
            <mat-radio-button [value]="false">Use a different company</mat-radio-button>
          </mat-radio-group>

          @if (!useDefaultCompany) {
            <div style="margin-top: 10px">
              <app-company-search [required]="true" (companyValidityChange)="companyValidity = $event"
                [formControl_]="companyControl" (companySelection)="selectedCompany = $event"
              ></app-company-search>
            </div>
          }
        </div>
        <div mat-dialog-actions style="display: flex; justify-content: space-between">
          <button mat-flat-button mat-dialog-close>Cancel</button>
          <button mat-flat-button color="primary" (click)="confirm()"
            [disabled]="useDefaultCompany ? false : !companyValidity">
            Confirm
          </button>
        </div>
        `,
    standalone: true,
    imports: [
        CommonModule,
        MatDialogContent,
        MatRadioModule,
        FormsModule,
        CompanySearchComponent,
        MatDialogActions,
        MatButtonModule
    ]
})
export class CompanyChooseDialogComponent {
    useDefaultCompany = true;
    companyControl = new UntypedFormControl(null);
    companyValidity = false;
    selectedCompany = null;
    constructor(
        @Inject(MAT_DIALOG_DATA) public budget: Budget,
        private dialogRef: MatDialogRef<CompanyChooseDialogComponent>
    ) {
    }

    confirm() {
        const dialogResult = this.useDefaultCompany ? true : this.selectedCompany;
        this.dialogRef.close(dialogResult);
    }
}